module.exports = __webpack_public_path__ + "static/mondrian-b95eb7e0f320fd2059b3725409aac10c.gif";